export const DELAY = 1000;
export const DOMAIN = "./../";
//export const DOMAIN = "http://localhost:5832";



// WEBPACK FOOTER //
// ./src/utilities/consts.js